export const gainToDb = gain => {
  //toFixed returns string
  return parseFloat((20 * Math.log10(gain)).toFixed(1))
}
